import * as duckdb from "@duckdb/duckdb-wasm";
import { useEffect } from "react";

import { Resolvable, useResolvable } from "lib/resolvable";

const PUBLIC_URL = process.env.PUBLIC_URL;

const DUCKDB_BUNDLES: duckdb.DuckDBBundles = {
  mvp: {
    mainModule: PUBLIC_URL + "/duckdb-mvp.wasm",
    mainWorker: PUBLIC_URL + "/duckdb-browser-mvp.worker.js",
  },
  eh: {
    mainModule: PUBLIC_URL + "/duckdb-eh.wasm",
    mainWorker: PUBLIC_URL + "/duckdb-browser-eh.worker.js",
  },
};
export function useDuckDB() {
  const [state, setState] = useResolvable<duckdb.AsyncDuckDB>();

  useEffect(() => {
    setState({ status: Resolvable.Status.RUNNING });
    (async () => {
      try {
        // Select a bundle based on browser checks
        const bundle = await duckdb.selectBundle(DUCKDB_BUNDLES);
        // Instantiate the asynchronus version of DuckDB-wasm
        const worker = new Worker(bundle.mainWorker!);
        const logger = new duckdb.ConsoleLogger(duckdb.LogLevel.WARNING);
        const db = new duckdb.AsyncDuckDB(logger, worker);
        await db.instantiate(bundle.mainModule, bundle.pthreadWorker);
        setState({
          status: Resolvable.Status.COMPLETED,
          value: db,
        });
      } catch (error) {
        setState({
          status: Resolvable.Status.FAILED,
          error,
        });
      }
    })();
  }, [setState]);

  return state;
}
